import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { updateAutoparkById } from '../../store/admin/autoparkSlice';
import { IAutopark } from '../../services/autopark.service';
import EditAutoparkModal from '../Modal/EditAutoparkModal';
import './autoparkDetails.css';

interface AutoparkDetailsProps {
  autopark: IAutopark;
}

function AutoparkDetails({ autopark }: AutoparkDetailsProps) {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user.user);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleEditClick = () => {
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
  };

  const handleEditSuccess = () => {
    // Redux автоматически обновит данные после успешного редактирования
    setIsEditModalOpen(false);
  };

  return (
    <div className="autopark-details-page__container">
      {/* Основная информация */}
      <div className="autopark-info">
        <div className="autopark-info__header">
          <h1 className="autopark-info__title">Автопарк "{autopark.tradeName || autopark.legalName || 'ЭПЛ'}"</h1>
          {user.role === 'admin' && (
            <button className="autopark-info__edit-button" onClick={handleEditClick}>
              Внести изменения
            </button>
          )}
        </div>

        <div className="autopark-info__content">
          <div className="info-field">
            <span className="info-field__label">Торговое наименование:</span>
            <span className="info-field__value">{autopark.tradeName || 'Не указано'}</span>
          </div>
          <div className="info-field">
            <span className="info-field__label">Юридическое наименование:</span>
            <span className="info-field__value">{autopark.legalName || 'ООО "Автопарк"'}</span>
          </div>
          <div className="info-field">
            <span className="info-field__label">ФИО владельца:</span>
            <span className="info-field__value">{autopark.fullnameOwner || 'Алексей Иванович Алексеев'}</span>
          </div>
          <div className="info-field">
            <span className="info-field__label">ФИО сотрудника:</span>
            <span className="info-field__value">{autopark.fullnameEmployee || 'Алексей Иванович Алексеев'}</span>
          </div>
          <div className="info-field">
            <span className="info-field__label">Телефон:</span>
            <span className="info-field__value">{autopark.phone || '+7 (921) 345 67 89'}</span>
          </div>
          <div className="info-field">
            <span className="info-field__label">Email:</span>
            <span className="info-field__value">{autopark.email || 'email@yandex.ru'}</span>
          </div>

          {/* Показываем внешний ID только если он есть */}
          {autopark.externalID && (
            <div className="info-field">
              <span className="info-field__label">Внешний ID:</span>
              <span className="info-field__value">{autopark.externalID}</span>
            </div>
          )}
        </div>
      </div>

      {/* Реквизиты */}
      <div className="autopark-requisites">
        <h2 className="autopark-requisites__title">
          Реквизиты автопарка "{autopark.tradeName || autopark.legalName || 'ЭПЛ'}"
        </h2>
        <div className="autopark-requisites__content">
          <div className="requisites-column">
            <div className="info-field">
              <span className="info-field__label">ИНН:</span>
              <span className="info-field__value">{autopark.inn || '13748490'}</span>
            </div>
            <div className="info-field">
              <span className="info-field__label">КПП:</span>
              <span className="info-field__value">{autopark.kpp || '13748490'}</span>
            </div>
            <div className="info-field">
              <span className="info-field__label">ОГРН:</span>
              <span className="info-field__value">{autopark.ogrn || '13748490'}</span>
            </div>

            {/* Показываем тип организации только если он есть */}
            {/* {(autopark).orgType && (
              <div className="info-field">
                <span className="info-field__label">Тип организации:</span>
                <span className="info-field__value">
                  {(autopark).orgType === 'fns' ? 'ФНС' : (autopark).orgType}
                </span>
              </div>
            )} */}
            <div className="info-field">
              <span className="info-field__label">Фактический адрес:</span>
              <span className="info-field__value">
                {autopark.actualAddress || 'Санкт-Петербург, Волхонское шоссе, 5'}
              </span>
            </div>
            <div className="info-field">
              <span className="info-field__label">Юридический адрес:</span>
              <span className="info-field__value">
                {autopark.legalAddress || 'Санкт-Петербург, Волхонское шоссе, 5'}
              </span>
            </div>
            {/* Показываем индекс только если он есть */}
            {autopark.index && (
              <div className="info-field">
                <span className="info-field__label">Почтовый индекс:</span>
                <span className="info-field__value">{autopark.index}</span>
              </div>
            )}
          </div>
          <div className="requisites-column">
            <div className="info-field">
              <span className="info-field__label">БИК:</span>
              <span className="info-field__value">{autopark.bik || 'Не указан'}</span>
            </div>
            <div className="info-field">
              <span className="info-field__label">Название банка:</span>
              <span className="info-field__value">{autopark.bankName || 'Не указан'}</span>
            </div>
            <div className="info-field">
              <span className="info-field__label">Расчетный счет:</span>
              <span className="info-field__value">{autopark.currentAccount || 'Не указан'}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Модальное окно редактирования */}
      <EditAutoparkModal
        isOpen={isEditModalOpen}
        onClose={handleCloseEditModal}
        onSuccess={handleEditSuccess}
        autopark={autopark}
      />
    </div>
  );
}

export default AutoparkDetails;
